import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Col, Drawer, Modal, Row, Spin, Tooltip } from 'antd';

import { CloseIcon, Info, RedirectIcon } from '../../assets/icons';
import InitiateTransferModal from '../../pages/Account/Transaction/InitiateTransferModal';
import TransactionDetailsModal from '../../pages/Account/Transaction/TransactionDetailsModal';
import TransferCompleteModal from '../../pages/Account/Transaction/TransferCompleteModal';
import BankAccountModal from '../LinkBankAccount/BankAccountModal';

// import { NewTransfer } from '../../utils/constant';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { getFundingSources } from '../../services/AccountApi/paymentMethodApi';
import { fetchPortfolioCardData } from '../../services/PortfolioApi/portfolioApi';
import { featchLastDividendAction, fetchAccountValueDataAction } from '../../store/reducer/portfolioSlice';
import { toastNotify } from '../../utils/toastNotify';
import debounce from 'lodash/debounce';
import { getUsCurrencyFormat, getUsPercentageFormat } from '../../utils/usCurrencyFormatter';

import { COMPLETE_VERIFICATION_FIRST, KYC_NOT_VERIFIED_MESSAGE, WARN_DWOLLA_PENDING, checkOnboardingComplete, TOOLTIP_TEXT } from '../../utils/constant';
import './PortfolioCard.scss';
import { portfolioBalance } from '../../constants/PortfolioBalance';

const handleKeyActivate = (callback) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    callback(e);
  }
};

const APPRECIATION_TYPE = {
  REALIZE: 'realize',
  UNREALIZE: 'unrealize',
};

const PortfolioCard = forwardRef(({ setLoading, isInvested }, ref) => {
  // const [navOpen, setNavOpen] = useState(false);
   const [isCardDataLoading, setIsCardDataLoading] = useState(false);
  const [isFundingSourcesLoading, setIsFundingSourcesLoading] = useState(false);
  const [transferModal, setTransferModal] = useState(false);
  const [transferCompleteModal, setTransferCompleteModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initiateTransferedData, setInitiateTransferedData] = useState({});
  const [transactionDetailsOpen, setTransactionDetailsOpen] = useState(false);
  const [pendingModalTransactionData] = useState({});
  const [isDepositModal, setIsDepositModal] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);
  const [cardData, setcardData] = useState({
    allTimeDividends: '',
    appreciationPtage: '',
    appreciationValue: '',
    cashBalance: '',
    lastDividend: '',
    netAccountValue: '',
    nextPayout: '',
    lastDividendDate: '',
    totalWalletBalance: '',
    fundsReservedForOpenOrders: '',
    availableWalletBalance: '',
  });
  const [isBankInFundingSource, setIsBankInFundingSource] = useState(false);
  const [availableBalance, setAvailableBalance] = useState(null);
  const [walletBalance, setWalletBalance] = useState(null);
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { accountValue, lastDividendData, loading } = useSelector((state) => state.portfolio);
  const userData = useSelector((state) => state.userData);
  let navigate = useNavigate();
    const {
    allTimeDividends,
    appreciationPtage,
    appreciationValue,
    cashBalance,
    lastDividend,
    netAccountValue,
    allTimeDividendsPercentage,
    isPendingWithdrawal,
    availableWalletBalance,
  } = cardData;
  const cashModalContent = [
    <>
      {isFundingSourcesLoading ? (
        <Spin className='w-100 text-center' spinning={isFundingSourcesLoading} />
      ) : (
        <>
          <div className='ins-note'>
            Your available wallet balance includes dividends from properties you own shares in and any uninvested funds from bank transfers, minus any
            funds committed to open buy orders.
          </div>
          <div className='acc-value-wrap'>
            <Row gutter={8} className='acc-value'>
              <Col span={14}>
                <span>Total wallet balance</span>
              </Col>
              <Col span={10}>
                <h4>{`$${getUsCurrencyFormat(walletBalance !== null ? walletBalance : (cardData?.totalWalletBalance ?? cardData?.cashBalance))}`}</h4>
              </Col>
            </Row>
            <Row gutter={8} className='acc-value'>
              <Col span={14}>
                <span>Pending orders or withdrawals</span>
              </Col>
              <Col span={10}>
                <h4>{`$${getUsCurrencyFormat(
                  walletBalance !== null && availableBalance !== null
                    ? Number(walletBalance) - Number(availableBalance)
                    : 0
                )}`}</h4>
              </Col>
            </Row>
          </div>
          <div className='net-value-wrap'>
            <Row className='net-value'>
              <Col span={14}>
                <span>Available wallet balance</span>
              </Col>
              <Col span={10}>
              <div className='justify-end d-flex'>
                <h4>{`$${getUsCurrencyFormat(
                  (() => {
                    const bal = availableBalance !== null ? availableBalance : (cardData?.availableWalletBalance ?? cardData?.cashBalance);
                    return Number(bal) < 0 ? 0 : bal;
                  })()
                )}`}</h4>
               {isPendingWithdrawal && Number(cashBalance) !== 0 && (
                    <Tooltip title="You have initiated a full withdrawal request.">
                      <span className="ml-8" style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <Info color="#958B88" size={18} />
                      </span>
                    </Tooltip>
                  )}
                </div>
              </Col>              
            </Row>
            {Number(cashBalance) > 0 && !isPendingWithdrawal && (
              <Row className='net-value mb-8'>
                <Col span={14}>
                  <span></span>
                </Col>
                <Col
                span={10}
                role='button'
                tabIndex={0}
                onClick={() => {
                  setIsCashModalOpen(false);
                  setTransferModal(true);
                }}
                onKeyDown={handleKeyActivate(() => {
                  setIsCashModalOpen(false);
                  setTransferModal(true);
                })}
                className='cursor-pointer'
              >
                <h4 className='transfer'>Transfer</h4>
              </Col>
            </Row>
            )}
          </div>
        </>
      )}
    </>,
  ];

  const dividendsModalContent = [
    <>
      {loading ? (
        <Spin className='w-100 text-center' spinning={loading} />
      ) : (
        <>
          <div className='ins-note'>
            Each share may distribute a dividend to its members based on its rental income performance. Dividends are expected to occur quarterly.
          </div>
          <div className='acc-value-wrap devidend-modal'>
            {/* Temporary Commented as per the CR changes */}
            {/* <Row gutter={8} className='acc-value'>
              <Col span={16}>
                <span>Your assets currently paying dividend</span>
              </Col>
              <Col span={8}>
                <h4>{`${lastDividendData?.data?.dividendPayingProperty} of ${lastDividendData?.data?.totalProperty}`}</h4>
              </Col>
            </Row> */}
            <Row gutter={8} className='acc-value'>
              <Col span={14}>
                <span>Last quarter dividend total</span>
              </Col>
              <Col span={10}>
                <h4>{`$${getUsCurrencyFormat(lastDividendData?.data?.totalLastDividend)}`}</h4>
              </Col>
            </Row>
            <Row gutter={8} className='acc-value'>
              <Col span={14}>
                <span>Last quarter dividend yield*</span>
              </Col>
              <Col span={10}>
                <h4>{`${getUsCurrencyFormat(lastDividendData?.data?.lastTotalDividendYield)}%`}</h4>
              </Col>
            </Row>
          </div>
          <div className='net-value-wrap'>
            <Row className='net-value mb-8'>
              <Col span={14}>
                <span>Year-to-date dividend earnings</span>
              </Col>
              <Col span={10}>
                <h4>{`$${getUsCurrencyFormat(lastDividendData?.data?.yearToDateDividendEarnings)}`}</h4>
              </Col>
            </Row>
            <Row className='net-value mb-8'>
              <Col span={14}>
                <span>All time dividend earnings</span>
              </Col>
              <Col span={10}>
                <h4>{`$${getUsCurrencyFormat(lastDividendData?.data?.allTimeDividend)}`}</h4>
              </Col>
            </Row>
            <Row className='net-value mb-8'>
              <Col span={14}>
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>Dividend Yield
                 <Tooltip title="Dividend yield is an annualized estimate based on current property performance and is not guaranteed. Actual returns may vary.">
                      <span className="ml-6" style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <Info color="#958B88" size={18} />
                      </span>
                    </Tooltip>
                </span>
              </Col>
              <Col span={10}>
                <h4>{`${getUsCurrencyFormat(lastDividendData?.data?.allTimeDividendYield)}%`}</h4>
              </Col>
            </Row>
          </div>
          <Button onClick={() => navigate('/account/transactions?transactionsType=dividend')} type='default w-100 mb-16'>
            View all dividend distributions
          </Button>
          <div className='note'>
            <p>* “Last Dividend yield” is the average yield percentage from properties in which you are a share holder.</p>
          </div>
        </>
      )}
    </>,
  ];
  const handleBankAddSuccess = () => {
    setBankModalOpen(false);
    setIsBankInFundingSource(true);
    setTransferModal(true);
  };
  //API Integration Function
  const fetchCardData = async (forceRefresh = false) => {
   if (isCardDataLoading && !forceRefresh) return cardData; // Prevent multiple calls
    try {
      setIsCardDataLoading(true);
      setLoading(true);
      const cardDataResp = await fetchPortfolioCardData();
      const portFolioCardData = cardDataResp.data;
      if (!cardDataResp.isError) {
        setcardData(portFolioCardData);
        if (portFolioCardData?.availableBalance !== undefined && portFolioCardData?.availableBalance !== null) {
          setAvailableBalance(portFolioCardData.availableBalance);
        }
      } else {
        toastNotify('error', cardDataResp?.message);
      }
      return portFolioCardData || null;
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setIsCardDataLoading(false);
      setLoading(false);
    }
  };

 const debouncedGetFundingSources = React.useMemo(
    () => debounce(async () => {
      if (isFundingSourcesLoading) return;
      
      try {
        setIsFundingSourcesLoading(true);
        const resp = await getFundingSources();
        if (!resp.isError) {
          const { banks, wallets } = resp.data;
          setIsBankInFundingSource(banks.length > 0);
          const wallet = wallets?.[0];
          const walletAvailableBalance = wallet?.availableBalance;
          const walletTotalBalance = wallet?.balance;
          if (walletAvailableBalance !== undefined && walletAvailableBalance !== null) {
            setAvailableBalance(walletAvailableBalance);
          }
          if (walletTotalBalance !== undefined && walletTotalBalance !== null) {
            setWalletBalance(walletTotalBalance);
          }
        } else {
          toastNotify('error', resp?.message);
        }
      } catch (error) {
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setIsFundingSourcesLoading(false);
      }
    }, 500),
    [isFundingSourcesLoading]
  );

  const getFundingSourcesFun = debouncedGetFundingSources;

  const showModal = async () => {
    setIsModalOpen(true);
    await dispatch(fetchAccountValueDataAction({}));
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [isTooltipModalOpen, setIsTooltipModalOpen] = useState('');
  const showTooltipModal = (value) => {
    setIsTooltipModalOpen(value);
  };
  const handleCancelTooltip = () => {
    setIsTooltipModalOpen('');
  };
  const [isDividendModalOpen, setIsDividendModalOpen] = useState(false);
  const showDividendModal = async () => {
    setIsDividendModalOpen(true);
    await dispatch(featchLastDividendAction({}));
  };
  const handleCancelDividend = () => {
    setIsDividendModalOpen(false);
  };
  const [isCashModalOpen, setIsCashModalOpen] = useState(false);
  const showCashModal = () => {
    setIsCashModalOpen(true);
    getFundingSourcesFun();
  };
  const handleCancelCash = () => {
    setIsCashModalOpen(false);
  };
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const handleInitiateTransfer = (val, isDeposit) => {
    // if (!userData?.userData?.isDwollaVerified) {
    //   toastNotify('error', WARN_DWOLLA_PENDING);
    //   return;
    // }
    if (val) {
      setIsDepositModal(isDeposit);
      setTransferModal(true);
    } else {
      userData?.userData?.isKYCVerified && userData?.userData?.isDwollaVerified
        ? setBankModalOpen(true)
        : !userData?.userData?.isKYCVerified
        ? checkOnboardingComplete(userData?.userData, userData?.counter)
          ? toastNotify('error', KYC_NOT_VERIFIED_MESSAGE)
          : toastNotify('error', <COMPLETE_VERIFICATION_FIRST navigate={navigate}/>)
        : toastNotify('error', WARN_DWOLLA_PENDING);
    }
  };

  useImperativeHandle(ref, () => ({
    fetchCardData: (forceRefresh = false) => fetchCardData(forceRefresh),
    refreshWalletBalance: getFundingSourcesFun,
    transferCompleteModal,
  }));

  // Add initialization effect
  useEffect(() => {
    if (!hasInitialized) {
      setHasInitialized(true);
      getFundingSourcesFun();
    }
  }, [hasInitialized]);

  const displayBalance = availableBalance !== null ? Number(availableBalance) : (Number(availableWalletBalance) || Number(cashBalance) || 0);
  const isBalancePositive = displayBalance > 0;
  const isBalanceZero = displayBalance === 0;
  const isBalanceNegative = displayBalance < 0;


  return (
    <>
      <div className='portfoliocard'>
        <div className='container-fluid'>
          <Row gutter={[16, 16]}>
            <Col span={24} md={8}>
              <div className='portfoliocard__block'>
                <div className='portfoliocard__inner'>
                  <h4>Total Account Value</h4>
                </div>
                <div className='portfoliocard__onevalue'>${getUsCurrencyFormat(netAccountValue + cashBalance)} </div>
                {Number(netAccountValue) !== 0 ? (
                  <div className='portfoliocard__alltimevalue inner-btn'>
                    <div className='value'>
                      {Number(appreciationValue) < 0 ? '-' : ''}$
                      {getUsCurrencyFormat(Number(appreciationValue) < 0 ? -Number(appreciationValue) : Number(appreciationValue) || 0)}
                      <span className={Number(appreciationValue) < 0 ? 'error' : 'success'}>
                        ({Number(appreciationPtage) > 0 ? '+' : ''}
                        {getUsCurrencyFormat(Number(appreciationPtage) || 0)}%)
                      </span>
                    </div>
                    <div className='head'>P & L</div>
                    <span onClick={showModal} onKeyDown={handleKeyActivate(showModal)} role='button' tabIndex={0} className='redirect cursor-pointer'>
                      <RedirectIcon verticalAlign='middle' color='#958B88' size='30' />
                    </span>
                  </div>
                ) : (
                  <div className='portfoliocard__novalue'>
                    {TOOLTIP_TEXT.ACCOUNT_VALUE_DESCRIPTION}
                  </div>
                )}
              </div>
            </Col>
            <Col span={24} md={8}>
              <div className='portfoliocard__block'>
                <div className='portfoliocard__inner'>
                  <h4>Last Dividend</h4>
                </div>
                <div className='portfoliocard__onevalue'>
                  {Number(lastDividend) < 0 ? '-' : ''}$
                  {getUsCurrencyFormat(Number(lastDividend) < 0 ? -Number(lastDividend) : Number(lastDividend) || 0)}
                </div>
                {Number(lastDividend) !== 0 ? (
                  <div className='portfoliocard__alltimevalue inner-btn'>
                    <div className='value'>
                      {Number(allTimeDividends) < 0 ? '-' : ''}$
                      {getUsCurrencyFormat(Number(allTimeDividends) < 0 ? -Number(allTimeDividends) : Number(allTimeDividends) || 0)}
                      <span style={{ display: 'inline-flex', alignItems: 'center' }}>({getUsPercentageFormat(Number(allTimeDividendsPercentage) || 0)}% dividend yield)
                        <Tooltip title="Dividend yield is an annualized estimate based on current property performance and is not guaranteed. Actual returns may vary.">
                      <span className="ml-6" style={{ display: 'inline-flex', alignItems: 'center', }}>
                        <Info color="#958B88" size={18} />
                      </span>
                    </Tooltip>
                      </span>
                    </div>
                    <div className='head'>Total dividends paid</div>
                    <span onClick={showDividendModal} onKeyDown={handleKeyActivate(showDividendModal)} role='button' tabIndex={0} className='redirect cursor-pointer'>
                      <RedirectIcon verticalAlign='middle' color='#958B88' size='30' />
                    </span>
                  </div>
                ) : (
                  <div className='portfoliocard__novalue'>
                    Each share may distribute a dividend to its members based on its rental income performance. Dividends are expected to occur
                    quarterly.
                  </div>
                )}
              </div>
            </Col>
            <Col span={24} md={8}>
              <div className='portfoliocard__block'>
                <div className='portfoliocard__inner'>
                  <h4 className='w-100 d-flex'>
                    <span>{portfolioBalance.POSITIVE_BALANCE}</span>
                    {Number(cashBalance) !== 0 && !isPendingWithdrawal ? (
                      <span
                        className='cursor-pointer ml-8 transfer'
                        role='button'
                        tabIndex={0}
                        onClick={() => handleInitiateTransfer(isBankInFundingSource, false)}
                        onKeyDown={handleKeyActivate(() => handleInitiateTransfer(isBankInFundingSource, false))}
                      >
                        Transfer
                      </span>
                    ) : (
                      ''
                    )}
                  </h4>
                </div>
                <div className='portfoliocard__onevalue d-flex align-items-center'>
                  ${getUsCurrencyFormat(isBalanceNegative ? 0 : displayBalance || 0)}
                  {isPendingWithdrawal && !isBalanceZero && (
                    <Tooltip title="You have initiated a full withdrawal request.">
                      <span className="ml-8" style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <Info color="#958B88" size={18} />
                      </span>
                    </Tooltip>
                  )}
                </div>
                {isBalancePositive ? (
                  <div className='portfoliocard__alltimevalue inner-btn'>
                    <div className='portfoliocard__novalue'>
                      Your account balance includes dividends paid from properties you own shares in, plus any uninvested cash from bank transfers.
                    </div>
                    <span onClick={showCashModal} onKeyDown={handleKeyActivate(showCashModal)} role='button' tabIndex={0} className='redirect cursor-pointer'>
                      <RedirectIcon verticalAlign='middle' color='#958B88' size='30' />
                    </span>
                  </div>
                ) : Number(cashBalance) !== 0 && isBalanceZero ? (
                  <div className='portfoliocard__alltimevalue inner-btn'>
                    <div className='portfoliocard__novalue'>
                      Your available wallet balance includes dividends from properties you own shares in and any uninvested funds from bank transfers,
                      minus any funds committed to open buy orders.
                    </div>
                    <span onClick={showCashModal} onKeyDown={handleKeyActivate(showCashModal)} role='button' tabIndex={0} className='redirect cursor-pointer'>
                      <RedirectIcon verticalAlign='middle' color='#958B88' size='30' />
                    </span>
                  </div>
                ) : (
                  <div className='portfoliocard__novalue'>
                    Your available wallet balance includes dividends from properties you own shares in and any uninvested funds from bank transfers,
                    minus any funds committed to open buy orders.
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {transferModal && (
        <InitiateTransferModal
          isTransferModalOpen={transferModal}
          closeTransferModal={() => setTransferModal()}
          openTransferCompleteModal={setTransferCompleteModal}
          initiateTransferedData={setInitiateTransferedData}
          // modalType={NewTransfer.Portfolio}
          isDepositModal={isDepositModal}
        />
      )}
      {transferCompleteModal && (
        <TransferCompleteModal
          transferCompleteModal={transferCompleteModal}
          setTransferCompleteModal={() => {
            setTransferCompleteModal();
            fetchCardData();
          }}
          setTransactionDetailsOpen={() => setTransactionDetailsOpen()}
          openInitiateTransfer={() => setTransferModal(true)}
          initiateTransferedData={initiateTransferedData}
        />
      )}
      {transactionDetailsOpen && (
        <TransactionDetailsModal
          transactionDetailsOpen={transactionDetailsOpen}
          setTransactionDetailsOpen={() => setTransactionDetailsOpen()}
          modalTransactionData={pendingModalTransactionData}
        />
      )}
      {bankModalOpen && (
        <BankAccountModal
          bankModalOpen={bankModalOpen}
          setBankModalOpen={(value) => setBankModalOpen(value)}
          onSuccess={() => handleBankAddSuccess()}
          onClose={(value) => setBankModalOpen(false)}
        />
      )}
      {screenMD ? (
        <Modal
          title='Total Account Value'
          open={isModalOpen}
          onCancel={handleCancel}
          footer={null}
          header={null}
          className='portfolio-overview-modals newaccount-popup'
        >
          <>
            {loading ? (
              <Spin className='w-100 text-center' spinning={loading} />
            ) : (
              <>
                <div className='ins-note'>
                  {TOOLTIP_TEXT.ACCOUNT_VALUE_DESCRIPTION}
                </div>
                <div className='acc-value-wrap'>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <span>Net Account Value(NAV)</span>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.netAccountValue)}`}</h4>
                    </Col>
                  </Row>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <span>Total Wallet balance</span>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.cashBalance)}`}</h4>
                    </Col>
                  </Row>
                </div>
                <div className='net-value-wrap'>
                  <Row className='net-value'>
                    <Col span={14}>
                      <span>Total Account Value*</span>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.totalAccountValue)}`}</h4>
                    </Col>
                  </Row>
                </div>
                <div className='acc-value-wrap'>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <span>All time contributions</span>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.allTimeContribution)}`}</h4>
                    </Col>
                  </Row>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <Tooltip title='The appreciation returns rewarded to you after selling your shares for cash.'>
                        <span className='acc-value-label tooltip'>
                          Realized share appreciation
                          <span>
                            <Info marginLeft='8px' verticalAlign='middle' />
                          </span>
                        </span>
                      </Tooltip>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.realizedGain)}`}</h4>
                    </Col>
                  </Row>
                  {/* <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <Tooltip title='The increase in the value of all asset shares you own that has yet to be sold for cash.'>
                        <span className='acc-value-label tooltip'>
                          Unrealized share appreciation
                          <span>
                            <Info marginLeft='8px' verticalAlign='middle' />
                          </span>
                        </span>
                      </Tooltip>
                    </Col>
                    <Col span={10}>
                      <h4>
                        {`${Number(accountValue?.data?.unrealizedAppreciation) < 0 ? '-' : '+'} $${
                          Number(accountValue?.data?.unrealizedAppreciation) < 0
                            ? getUsCurrencyFormat(accountValue?.data?.unrealizedAppreciation?.toString()?.slice(1))
                            : getUsCurrencyFormat(accountValue?.data?.unrealizedAppreciation)
                        }`}
                      </h4>
                    </Col>
                  </Row> */}
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <span>Total dividends received</span>
                    </Col>
                    <Col span={10}>
                      <h4>
                        {`${Number(accountValue?.data?.totalDividend) < 0 ? '-' : '+'} $${
                          Number(accountValue?.data?.totalDividend) < 0
                            ? getUsCurrencyFormat(accountValue?.data?.totalDividend?.toString()?.slice(1))
                            : getUsCurrencyFormat(accountValue?.data?.totalDividend)
                        }`}
                      </h4>
                    </Col>
                  </Row>
                </div>
                <div className='net-value-wrap'>
                  <Row className='net-value'>
                    <Col span={14}>
                      <span>All time gain*</span>
                    </Col>
                    <Col span={10}>
                      <h4>
                        {`${Number(accountValue?.data?.allTimeGain) < 0 ? '-' : '+'} $${
                          Number(accountValue?.data?.allTimeGain) < 0
                            ? getUsCurrencyFormat(accountValue?.data?.allTimeGain?.toString()?.slice(1))
                            : getUsCurrencyFormat(accountValue?.data?.allTimeGain)
                        }`}
                      </h4>
                    </Col>
                  </Row>
                </div>
                <div className='note'>
                  <p>* {TOOLTIP_TEXT.ACCOUNT_VALUE_FOOTNOTE}</p>
                </div>
              </>
            )}
          </>
        </Modal>
      ) : (
        <>
          <Drawer
            className='portfolio-overview-modals footer-shadow quickbuy--drawer'
            width='100%'
            onClose={handleCancel}
            open={isModalOpen}
            closeIcon={<CloseIcon />}
            title='Total Account Value'
            footer={false}
          >
            <>
              {loading ? (
                <Spin className='w-100 text-center' spinning={loading} />
              ) : (
                <>
                  <div className='ins-note'>
                    {TOOLTIP_TEXT.ACCOUNT_VALUE_DESCRIPTION}
                  </div>
                  <div className='acc-value-wrap'>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span>Net Account Value(NAV)</span>
                      </Col>
                      <Col span={10}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.netAccountValue)}`}</h4>
                      </Col>
                    </Row>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span>Total Wallet balance</span>
                      </Col>
                      <Col span={10}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.cashBalance)}`}</h4>
                      </Col>
                    </Row>
                  </div>
                  <div className='net-value-wrap'>
                    <Row className='net-value'>
                      <Col span={10}>
                        <span>Total Account Value*</span>
                      </Col>
                      <Col span={14}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.totalAccountValue)}`}</h4>
                      </Col>
                    </Row>
                  </div>
                  <div className='acc-value-wrap'>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span>All time contributions</span>
                      </Col>
                      <Col span={10}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.allTimeContribution)}`}</h4>
                      </Col>
                    </Row>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span
                          onClick={() => showTooltipModal(APPRECIATION_TYPE.REALIZE)}
                          onKeyDown={handleKeyActivate(() => showTooltipModal(APPRECIATION_TYPE.REALIZE))}
                          role='button'
                          tabIndex={0}
                          className='acc-value-label tooltip'
                        >
                          Realized share appreciation
                        </span>
                      </Col>
                      <Col span={10}>
                        <h4>
                          {`${Number(accountValue?.data?.realizedGain) < 0 ? '-' : '+'} $${
                            Number(accountValue?.data?.realizedGain) < 0
                              ? getUsCurrencyFormat(accountValue?.data?.realizedGain?.toString()?.slice(1))
                              : getUsCurrencyFormat(accountValue?.data?.realizedGain)
                          }`}
                        </h4>
                      </Col>
                    </Row>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span
                          onClick={() => showTooltipModal(APPRECIATION_TYPE.UNREALIZE)}
                          onKeyDown={handleKeyActivate(() => showTooltipModal(APPRECIATION_TYPE.UNREALIZE))}
                          role='button'
                          tabIndex={0}
                          className='acc-value-label tooltip'
                        >
                          Unrealized share appreciation
                        </span>
                      </Col>
                      <Col span={10}>
                        <h4>
                          {`${Number(accountValue?.data?.unrealizedAppreciation) < 0 ? '-' : '+'} $${
                            Number(accountValue?.data?.unrealizedAppreciation) < 0
                              ? getUsCurrencyFormat(accountValue?.data?.unrealizedAppreciation?.toString()?.slice(1))
                              : getUsCurrencyFormat(accountValue?.data?.unrealizedAppreciation)
                          }`}
                        </h4>
                      </Col>
                    </Row>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span>Total dividends received</span>
                      </Col>
                      <Col span={10}>
                        <h4>
                          {`${Number(accountValue?.data?.totalDividend) < 0 ? '-' : '+'} $${
                            Number(accountValue?.data?.totalDividend) < 0
                              ? getUsCurrencyFormat(accountValue?.data?.totalDividend?.toString()?.slice(1))
                              : getUsCurrencyFormat(accountValue?.data?.totalDividend)
                          }`}
                        </h4>
                      </Col>
                    </Row>
                  </div>
                  <div className='net-value-wrap'>
                    <Row className='net-value'>
                      <Col span={10}>
                        <span>All time gain*</span>
                      </Col>
                      <Col span={14}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.allTimeGain)}`}</h4>
                      </Col>
                    </Row>
                  </div>
                  <div className='note'>
                    <p>* {TOOLTIP_TEXT.ACCOUNT_VALUE_FOOTNOTE}</p>
                  </div>
                </>
              )}
            </>
          </Drawer>
          <Modal
            open={isTooltipModalOpen === APPRECIATION_TYPE.REALIZE}
            onCancel={handleCancelTooltip}
            footer={null}
            header={null}
            width={272}
            className='tooltip-modals'
            centered
          >
            <h4>Realized shares appreciation</h4>
            <div className='ins-note'>The appreciation returns rewarded to you after selling your shares for cash.</div>
          </Modal>
          <Modal
            open={isTooltipModalOpen === APPRECIATION_TYPE.UNREALIZE}
            onCancel={handleCancelTooltip}
            footer={null}
            header={null}
            width={272}
            className='tooltip-modals'
            centered
          >
            <h4>Unrealized share appreciation</h4>
            <div className='ins-note'>The increase in the value of all asset shares you own that has yet to be sold for cash.</div>
          </Modal>
        </>
      )}

      {screenMD ? (
        <Modal
          title='Last Dividend'
          open={isDividendModalOpen}
          onCancel={handleCancelDividend}
          footer={null}
          header={null}
          className='portfolio-overview-modals newaccount-popup'
        >
          {dividendsModalContent}
        </Modal>
      ) : (
        <Drawer
          className='portfolio-overview-modals footer-shadow quickbuy--drawer'
          width='100%'
          onClose={handleCancelDividend}
          open={isDividendModalOpen}
          closeIcon={<CloseIcon />}
          footer={false}
          title='Last Dividend'
        >
          {dividendsModalContent}
        </Drawer>
      )}

      {screenMD ? (
        <Modal
          title='Available Wallet Balance'
          open={isCashModalOpen}
          onCancel={handleCancelCash}
          footer={null}
          header={null}
          className='portfolio-overview-modals newaccount-popup'
        >
          {cashModalContent}
        </Modal>
      ) : (
        <Drawer
          className='portfolio-overview-modals footer-shadow quickbuy--drawer'
          width='100%'
          onClose={handleCancelCash}
          open={isCashModalOpen}
          closeIcon={<CloseIcon />}
          footer={false}
          title='Available Wallet Balance'
        >
          {cashModalContent}
        </Drawer>
      )}
    </>
  );
});

export default PortfolioCard;
